/**
 * Message copy the BFF writes into a channel, shared so the live path and the
 * client's fixtures cannot drift.
 */

/**
 * Deliberately in nobody's voice: both members read this, so "You ended this
 * chat." reads as a lie on the jobseeker's side.
 */
export const CHAT_ENDED_NOTE = 'This chat has ended.';
